var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 198.43",
    style: {
      enableBackground: "new 0 0 283.46 198.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FECB8E;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#931A25;}\r\n\t.st2{fill:#931A25;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.74,71.84c-26.31-15.42-66.08-32.62-116.83-35.23C93.59,33.18,39.88,50.12,6.56,71.84 C29.03,45.4,69.9,21.06,126.31,18C196.94,14.18,247.92,39.5,276.74,71.84z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.56,128.95c26.31,14.91,66.08,31.55,116.84,34.08c66.31,3.31,120.02-13.07,153.34-34.08 c-22.48,25.57-63.33,49.12-119.75,52.09C86.36,184.74,35.37,160.23,6.56,128.95z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.24,90.38c-2.09,0-4.16,0-6.23,0c-3.06-12.16-14.31-19.01-33.08-20.99c0-1.44,0-2.89,0-4.34 C94.54,67.22,108.5,75.83,111.24,90.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.65,90.71c-2.92,0-5.85,0-8.77,0c-4.3-17.1-20.12-26.73-46.51-29.5c0-2.04,0-4.08,0-6.12 C103.15,58.15,122.78,70.26,126.65,90.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.65,94.18c2.92,0,5.84,0,8.76,0c4.3,17.09,20.11,26.72,46.51,29.5c0,2.04,0,4.08,0,6.12 C33.13,126.72,13.51,114.62,9.65,94.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.86,79.18c-1.35,1.29-4.27,1.58-5.75,2.8c-14.56-9.34-39.06-3.64-39.06,10.87 c0,8.33,9.19,15.68,24.45,14.76c9.78-0.6,15.1-4.4,19.4-8.86c2.32,0.57,4.29,1.36,6.47,2.02c-5.59,7.44-14.95,12.41-31.63,11.5 c-15.69-0.85-27.94-9.68-26.61-21.75c1.04-9.33,12-17.27,26.85-18.02C77.59,71.86,85.26,74.94,90.86,79.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.29,92.85c-14.46,0-28.92,0-43.38,0c0.74-1.6,1.83-2.96,2.88-4.35c10.63,0,21.26,0,31.88,0 c-0.28-1.53-1.38-2.53-1.92-3.89c2.12-0.7,4.55-2.03,6.47-2.33C96.84,84.99,98.22,88.5,98.29,92.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.86,95.19c2.31,12.64,14.06,19.16,32.36,21.44c0.02,1.47-0.42,2.64-0.24,4.2 c-21.82-2.07-36.47-10.96-38.59-25.79C28.53,95.09,30.49,95.26,32.86,95.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.37,94.6c1.18,0.38,2.07,0.88,2.69,1.49c0.59,0.58,0.99,1.25,1.19,2.03c0.17,0.53,0.26,1.38,0.26,2.54 h-12.91c0.05,1.17,0.47,2.12,1.27,2.82c0.79,0.71,2.01,1.06,3.67,1.06c1.55,0,2.78-0.33,3.7-1c0.52-0.39,0.88-0.84,1.1-1.35h2.94 c-0.08,0.42-0.34,0.89-0.77,1.41c-0.44,0.52-0.93,0.94-1.46,1.27c-0.9,0.58-2.01,0.96-3.34,1.16c-0.71,0.11-1.52,0.17-2.42,0.17 c-2.2,0-4.06-0.52-5.59-1.56c-1.53-1.04-2.29-2.5-2.29-4.38c0-1.85,0.77-3.35,2.31-4.51c1.54-1.16,3.55-1.73,6.03-1.73 C112.98,94.03,114.2,94.22,115.37,94.6z M116.44,99.12c-0.12-0.84-0.4-1.5-0.84-2.01c-0.81-0.93-2.17-1.4-4.06-1.4 c-1.36,0-2.5,0.32-3.42,0.96c-0.92,0.64-1.41,1.46-1.46,2.44H116.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.99,94.29h3.87l4.08,4.05l4.13-4.05l3.63,0.06l-5.99,5.55l6.25,5.9h-3.81l-4.41-4.32l-4.28,4.32h-3.78 l6.25-5.9L124.99,94.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.81,94.35h2.92v1.52c0.6-0.52,1.25-0.93,1.96-1.22c1-0.43,2.19-0.64,3.56-0.64c2.01,0,3.73,0.5,5.13,1.5 c1.41,1,2.11,2.43,2.11,4.28c0,2.51-1.02,4.3-3.04,5.38c-1.29,0.68-2.79,1.02-4.5,1.02c-1.35,0-2.47-0.19-3.38-0.57 c-0.53-0.22-1.12-0.58-1.78-1.11v5.88h-2.98V94.35z M158.03,103.36c0.92-0.75,1.39-1.88,1.39-3.39c0-0.92-0.21-1.71-0.62-2.36 c-0.77-1.27-2.19-1.9-4.26-1.9c-2.07,0-3.49,0.67-4.26,2.01c-0.41,0.71-0.61,1.63-0.61,2.73c0,0.89,0.21,1.64,0.61,2.27 c0.78,1.19,2.2,1.78,4.26,1.78C155.94,104.5,157.1,104.12,158.03,103.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.3,94.6c1.17,0.38,2.07,0.88,2.68,1.49c0.59,0.58,0.99,1.25,1.19,2.03c0.18,0.53,0.26,1.38,0.26,2.54 h-12.91c0.06,1.17,0.48,2.12,1.27,2.82c0.79,0.71,2.01,1.06,3.67,1.06c1.55,0,2.78-0.33,3.7-1c0.52-0.39,0.88-0.84,1.1-1.35h2.94 c-0.08,0.42-0.34,0.89-0.77,1.41c-0.43,0.52-0.92,0.94-1.46,1.27c-0.9,0.58-2.01,0.96-3.34,1.16c-0.71,0.11-1.52,0.17-2.42,0.17 c-2.2,0-4.06-0.52-5.58-1.56c-1.53-1.04-2.29-2.5-2.29-4.38c0-1.85,0.77-3.35,2.31-4.51c1.54-1.16,3.55-1.73,6.03-1.73 C177.9,94.03,179.12,94.22,180.3,94.6z M181.36,99.12c-0.12-0.84-0.4-1.5-0.83-2.01c-0.81-0.93-2.17-1.4-4.06-1.4 c-1.36,0-2.5,0.32-3.42,0.96c-0.92,0.64-1.41,1.46-1.46,2.44H181.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.69,94.29h2.83v1.99c0.23-0.39,0.8-0.86,1.71-1.41c0.9-0.56,1.95-0.83,3.13-0.83c0.05,0,0.15,0,0.28,0.01 c0.13,0.01,0.36,0.02,0.68,0.04v2.04c-0.18-0.02-0.34-0.03-0.49-0.04c-0.15-0.01-0.31-0.01-0.49-0.01c-1.5,0-2.66,0.32-3.46,0.94 c-0.81,0.63-1.21,1.35-1.21,2.16v6.62h-2.98V94.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.9,91.08h3.02v3.21h2.83v1.58h-2.83v7.51c0,0.4,0.21,0.67,0.63,0.81c0.23,0.08,0.62,0.12,1.16,0.12 c0.15,0,0.3,0,0.47,0c0.16-0.01,0.35-0.02,0.57-0.04v1.54c-0.34,0.07-0.69,0.11-1.06,0.14c-0.37,0.03-0.77,0.04-1.21,0.04 c-1.39,0-2.34-0.23-2.84-0.69c-0.5-0.46-0.74-1.06-0.74-1.8v-7.62h-2.4v-1.58h2.4V91.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.13,90.01h3.03v2.19h-3.03V90.01z M219.13,94.35h3.03v11.45h-3.03V94.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.85,102.19c0.09,0.64,0.34,1.14,0.76,1.48c0.77,0.63,2.1,0.94,4,0.94c1.13,0,2.12-0.15,2.98-0.47 c0.85-0.31,1.29-0.79,1.29-1.44c0-0.5-0.34-0.87-1.03-1.13c-0.44-0.16-1.3-0.34-2.59-0.55l-2.41-0.39 c-1.53-0.24-2.67-0.51-3.4-0.82c-1.3-0.52-1.95-1.24-1.95-2.17c0-1.09,0.61-1.97,1.84-2.64c1.22-0.67,2.87-1.01,4.95-1.01 c2.71,0,4.67,0.51,5.86,1.53c0.75,0.64,1.12,1.34,1.09,2.08h-2.82c-0.05-0.43-0.3-0.83-0.73-1.18c-0.7-0.51-1.92-0.76-3.65-0.76 c-1.15,0-2.03,0.14-2.62,0.42s-0.89,0.65-0.89,1.1c0,0.5,0.39,0.9,1.17,1.2c0.45,0.18,1.11,0.34,1.99,0.47l2.01,0.31 c2.18,0.34,3.65,0.66,4.39,0.97c1.16,0.5,1.74,1.28,1.74,2.34c0,1.02-0.61,1.91-1.82,2.66c-1.22,0.74-3.06,1.12-5.54,1.12 c-2.68,0-4.57-0.39-5.68-1.16c-1.11-0.78-1.71-1.74-1.79-2.89H231.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.41,94.6c1.17,0.38,2.07,0.88,2.69,1.49c0.59,0.58,0.99,1.25,1.18,2.03c0.17,0.53,0.26,1.38,0.26,2.54 h-12.91c0.06,1.17,0.48,2.12,1.27,2.82c0.79,0.71,2.01,1.06,3.67,1.06c1.55,0,2.78-0.33,3.7-1c0.52-0.39,0.88-0.84,1.1-1.35h2.94 c-0.07,0.42-0.34,0.89-0.77,1.41c-0.44,0.52-0.92,0.94-1.46,1.27c-0.9,0.58-2.01,0.96-3.34,1.16c-0.72,0.11-1.52,0.17-2.42,0.17 c-2.19,0-4.06-0.52-5.58-1.56c-1.53-1.04-2.29-2.5-2.29-4.38c0-1.85,0.77-3.35,2.31-4.51c1.54-1.16,3.55-1.73,6.03-1.73 C259.02,94.03,260.24,94.22,261.41,94.6z M262.48,99.12c-0.12-0.84-0.4-1.5-0.84-2.01c-0.81-0.93-2.17-1.4-4.06-1.4 c-1.36,0-2.5,0.32-3.42,0.96c-0.92,0.64-1.41,1.46-1.46,2.44H262.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.53,131.61v-8.04c0-2.52,1.68-3.71,5.79-3.71h8.29v11.75H102.53z M105.43,115.67l2.35-1.82l2.02,1.45 l1.82-1.45l2.56,1.82l-2.56,1.86l-1.82-1.45l-2.02,1.45L105.43,115.67z M106.38,129.38h6.19v-7.3h-4.18 c-1.62,0-2.02,0.26-2.02,1.11V129.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.32,137.68v-2.22h0.94c1.42,0,1.82-0.26,1.82-1.11v-14.49h3.98v9.53h0.54v2.23h-0.54v2.38 c0,2.47-1.55,3.7-5.32,3.7H120.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.06,131.61v-2.23h5.78v2.23H127.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.1,131.61v-2.23h5.79v2.23H132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.16,131.61v-2.23h5.79v2.23H137.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.21,131.61v-2.23H148v2.23H142.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.26,131.61v-2.23h5.79v2.23H147.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.3,131.61v-2.23h5.8v2.23H152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.15,131.61v-2.23h7.13v-9.53h3.91v9.53h0.61v2.23H156.15z M162.54,136.06l2.55-1.89l2.36,1.89l-2.36,1.82 L162.54,136.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.11,131.61v-2.23h5.8v2.23H167.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.17,131.61v-2.23h5.78v2.23H172.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.22,131.61v-2.23h5.79v2.23H177.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.26,131.61v-2.23h5.8v2.23H182.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.32,131.61v-2.23h5.78v2.23H187.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.36,131.61v-2.23h5.79v2.23H192.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.68,131.57v-2.22h14.01v-6.15c0-0.85-0.48-1.11-2.1-1.11h-6.4v-2.22h6.53c4.1,0,5.93,1.19,5.93,3.71v5.78 h0.61v2.22h-0.61v2.01h-3.97v-2.01H196.68z M203.88,115.6l2.48-1.89l2.63,1.89l-2.63,1.82L203.88,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.78,131.61v-2.23h5.79v2.23H214.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.84,131.61v-2.23h5.79v2.23H219.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.88,131.61v-2.23h5.79v2.23H224.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.94,131.61v-2.23h5.79v2.23H229.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.98,131.61v-2.23h5.8v2.23H234.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.04,131.61v-2.23h5.79v2.23H240.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245.09,131.61v-2.23h5.79v2.23H245.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250,131.61v-2.23h3.58v-16.63h4.04v18.86H250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.18,131.61v-18.86h3.9v18.86H261.18z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df7cd077fd1451aec4ba90914814d942.svg";
export { ForwardRef as ReactComponent };